import Color from 'color';
import React from 'react';

import { Badge } from '../Badge';
import { Description } from '../Description';
import { Icon } from '../Icon';
import { Link } from '../Link';

import styles from './ContrastChecker.module.scss';

export interface IContrastCheckerProps {
  color: string;
  dataTest?: string;
}

export const ContrastChecker: React.SFC<IContrastCheckerProps> = (props) => {
  let badge;
  let color;
  let description;
  let contrastRatio;

  try {
    color = Color(props.color);
  } catch (err) {
    return <Description variant="condensed">An invalid color was provided.</Description>;
  }

  contrastRatio = Color('#FFF').contrast(color).toFixed(1);

  if (contrastRatio >= 3) {
    badge = <Badge text="Accessible" variant="positive" dataTest="contrast-checker-badge" />;
    description = (
      <Description variant="condensed">
        This color has a Contrast Ratio to white of {contrastRatio}. That means it meets WCAG accessibility standards.
      </Description>
    );
  } else {
    badge = <Badge text="Not Accessible" variant="negative" dataTest="contrast-checker-badge" />;
    description = (
      <Description variant="condensed">
        This color has a Contrast Ratio to white of {contrastRatio}. That means it does not meet WCAG accessibility
        standards.
      </Description>
    );
  }

  return (
    <div data-test={props.dataTest}>
      {badge}
      <div className={styles.description}>
        {description}
        <Description variant="condensed">
          <span className={styles.link}>
            <Link.Prominent
              openInNewTab={true}
              text="Learn more"
              href="https://opengov.zendesk.com/hc/en-us/articles/360031639331-Color-Contrast-in-Reporting-Graphs"
            />
            <a
              role="button"
              href="https://opengov.zendesk.com/hc/en-us/articles/360031639331-Color-Contrast-in-Reporting-Graphs"
            >
              <Icon icon="arrow-right-small" className={styles.icon} ariaLabel="Learn more" />
            </a>
          </span>
        </Description>
      </div>
    </div>
  );
};
